import IFeatureItem from '../model/IFeatureItem';
import { GetCustomizeCar_customizeCar } from '../../gqlCustomise/graphql/queries/__generated__/GetCustomizeCar';
import featureIconMap from '../assets/FeatureIconMap';
import TransferGroupType from '../enum/TransferGroupType';
import CategoryFeatureTypes from '../../gqlCustomise/enum/CategoryFeatureTypes';
import ITransferGroup from '../model/ITransferGroup';
import CategoryPurpose from '../../gqlCustomise/enum/CategoryPurpose';

const formatDisplayFeaturesService = {
  stockFeaturesList(
    customizeCar: GetCustomizeCar_customizeCar,
    interiorCategoryCode: string,
    exteriorCategoryCode: string,
  ): Record<keyof typeof featureIconMap, Partial<IFeatureItem>> {
    const { transmissionLabel, shortname, motor, fuelType } = customizeCar.car.engine.attributes;

    return {
      color_label: {
        body: formatDisplayFeaturesService.getExteriorDetailsInfo(customizeCar, exteriorCategoryCode) ?? '',
      },
      transmission: {
        body: transmissionLabel ?? '',
      },
      body_type: {
        body: shortname ?? '',
      },
      interior: {
        body: formatDisplayFeaturesService.getInteriorDetailsInfo(customizeCar, interiorCategoryCode) ?? '',
      },
      engine: {
        body: motor ?? '',
      },
      fuel_type: {
        body: fuelType ?? '',
      },
    };
  },
  getInteriorDetailsInfo(customizeCar: GetCustomizeCar_customizeCar, interiorCategoryCode: string): string {
    let featureLabel;

    customizeCar.selectedFeatures.selected.forEach(selectedFeatureId => {
      const featureDetails = customizeCar.availableFeatures.find(feature => feature.code === selectedFeatureId);
      if (featureDetails && featureDetails.categoryCode === interiorCategoryCode) {
        featureLabel = featureDetails.label;
      }
    });

    return featureLabel;
  },

  getExteriorDetailsInfo(customizeCar: GetCustomizeCar_customizeCar, exteriorCategoryCode: string): string {
    let featureLabel;

    customizeCar.selectedFeatures.selected.forEach(selectedFeatureId => {
      const featureDetails = customizeCar.availableFeatures.find(feature => feature.code === selectedFeatureId);
      if (featureDetails?.categoryCode === exteriorCategoryCode) {
        featureLabel = featureDetails?.label;
      }
    });

    return featureLabel;
  },

  getAccessoriesByStock(customizeCar: GetCustomizeCar_customizeCar, featureCodeList: string[]) {
    const features: string[] = [];
    featureCodeList.forEach(list => {
      const featureDetails = customizeCar.availableFeatures.find(feature => feature.code === list);
      if (featureDetails) {
        const category = customizeCar?.availableFeatureCategories?.find(f => f.code === featureDetails.categoryCode);
        if (category?.attributes.categorypurpose === CategoryPurpose.ACCESSORY) {
          features.push(featureDetails?.label);
        }
      }
    });

    return features;
  },

  getTransferGroup(customizeCar: GetCustomizeCar_customizeCar) {
    const { selected, removed } = customizeCar?.selectedFeatures;
    const addedList = formatDisplayFeaturesService.getAccessoriesByStock(customizeCar, selected);
    const removedList = formatDisplayFeaturesService.getAccessoriesByStock(customizeCar, removed);
    let validGroup: ITransferGroup;
    let invalidGroup: ITransferGroup;

    if (addedList.length) {
      validGroup = {
        name: TransferGroupType.TRANSFER,
        transferOptions: [
          {
            type: CategoryFeatureTypes.ACCESSORIES,
            options: addedList,
          },
        ],
      };
    }

    if (removedList.length) {
      invalidGroup = {
        name: TransferGroupType.NOT_COMPATIBLE,
        transferOptions: [
          {
            type: CategoryFeatureTypes.ACCESSORIES,
            options: removedList,
          },
        ],
      };
    }

    return { validGroup, invalidGroup };
  },
};

export default formatDisplayFeaturesService;
